import { Card } from "@mui/material";
import CommonLayout from "components/CommonLayout";
import MDBox from "components/MDBox";
import ShowToast from "components/MDToast";
import MDTypography from "components/MDTypography";
import OrderDetail from "components/OrderDetails";
import ProductDetail from "components/ProductDetails";
import useTranslation from "hooks/Translation";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useLazyGetOrderByIdQuery } from "services/order";

const OrderDetails = () => {
  const t = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { id } = useParams();
  const [orderById] = useLazyGetOrderByIdQuery();
  const [orderData, setOrderData] = useState(null);

  const getOrderDetails = async () => {
    try {
      const res = await orderById({ id }).unwrap();
      if (res?.status === 200) {
        setOrderData(res?.data);
      }
    } catch (error) {
      console.log(error, "errror");
      ShowToast(error?.data?.message || "", "error");
    }
  };

  useEffect(() => {
    getOrderDetails();
  }, []);

  return (
    <CommonLayout>
      <Card sx={{ marginTop: 10, marginBottom: 10 }}>
        <MDBox
          // variant="gradient"
          bgColor="theme-1"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          sx={{ display: "flex", justifyContent: "space-between" }}
          // textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            {t.main.orderDetails}
          </MDTypography>

          <MDTypography
            variant="h6"
            color="white"
            mt={1}
            sx={{ cursor: "pointer" }}
            onClick={() =>
              navigate("/orders-management", { state: { value: state?.value } })
            }
          >
            {t.main.back}
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <OrderDetail orderData={orderData} />
        </MDBox>
      </Card>
    </CommonLayout>
  );
};

export default OrderDetails;
